import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Item from './Item'
import { KeyTagContent } from './Item/KeyTag/types'

const HelpBar = () => (
  <Box padding="s8" flexDirection="row" background="grey200" gap="s24">
    <Navigate />
    <Select />
    <Cancel />
  </Box>
)

const Navigate = () => (
  <Item.Wrapper>
    <Item.KeyTag content={{ type: KeyTagContent.Text, value: 'tab' }} />
    <Item.Text betweenKeys text={i18n.t('command_bar.help_bar.navigate.or')} />
    <Item.KeyTagGroup
      content={[
        { type: KeyTagContent.Icon, value: 'caret-up' },
        { type: KeyTagContent.Icon, value: 'caret-down' },
      ]}
    />
    <Item.Text text={i18n.t('command_bar.help_bar.navigate.to_navigate')} />
  </Item.Wrapper>
)

const Select = () => (
  <Item.Wrapper>
    <Item.KeyTag content={{ type: KeyTagContent.Text, value: 'return' }} />
    <Item.Text text={i18n.t('command_bar.help_bar.select.to_select')} />
  </Item.Wrapper>
)

const Cancel = () => (
  <Item.Wrapper>
    <Item.KeyTag content={{ type: KeyTagContent.Text, value: 'esc' }} />
    <Item.Text text={i18n.t('command_bar.help_bar.cancel.to_cancel')} />
  </Item.Wrapper>
)

export default React.memo(HelpBar)
